import React from 'react';

import { useOutletContext } from 'react-router-dom';
import _ from 'lodash';

import { Datatable } from './Datatable';

export const DatatablePage = () => {
  const { termCode, minCrn, isCourseUpdatable } = useOutletContext();
  return <Datatable termCode={termCode} crn={minCrn} isUpdatable={isCourseUpdatable} />;
};
